import { z } from 'zod';
import { requiredString } from '../helpers';
export const Parse_Attachment_1_ConfigValidator = z.object({
    fileName: requiredString('File name is required'),
    outputSchema: z.record(z.string(), z.any())
});
//# sourceMappingURL=parse-attachment-1.js.map